import { FC, Suspense, lazy } from 'react'
import { FullLoader } from '../../shared'
import { HealthDataModalHistoryProps } from './HealthDataModalHistory.model'

const LazyHealthDataModalHistory = lazy(() =>
  import(/* webpackChunkName: "recharts" */ './HealthDataModalHistory.component').then(
    ({ HealthDataModalHistory }) => ({
      default: HealthDataModalHistory,
    }),
  ),
)

const LazyLoadedHealthDataModalHistory: FC<HealthDataModalHistoryProps> = (props) => (
  <Suspense fallback={<FullLoader />}>
    <LazyHealthDataModalHistory {...props} />
  </Suspense>
)
export { LazyLoadedHealthDataModalHistory as HealthDataModalHistory }
